import axios from 'axios'
import config from '../helpers/config'
import IAccessibilityData from '../helpers/data/accessibilityData'

const getAssetAccessibilityData = (
	assetUid: string,
	entityUid: string,
	entityType: string,
	elementId: string,
	jwt?: string
): Promise<IAccessibilityData> => {
	const headers = jwt ? { authorization: `Bearer ${jwt}` } : {}

	return axios
		.request({
			method: 'get',
			url: `${config.getSlideApiGatewayPath()}/assets/${assetUid}/accessibility`,
			params: {
				entityUid,
				entityType,
				elementId,
			},
			headers,
		})
		.then(function (response) {
			return response.data
		})
		.catch(function (error) {
			console.error('Error fetching accessibility data:', error)
			return { altText: '', isDecorative: false }
		})
}

export default {
	getAssetAccessibilityData,
}
